import type { Value } from "@package/scratchpad-utils";

export function formatValue(v: Value | null | undefined): string | null {
  if (v == null) return null;
  if (typeof v === "boolean") return v ? "TRUE" : "FALSE";
  if (typeof v === "number") return v.toFixed(4);
  return String(v);
}
